export default "__VITE_ASSET__DpT9PLhv__"